module.exports = __webpack_public_path__ + "static/media/southern-nights.75fa08a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/southern-nights.png
// module id = 198
// module chunks = 0